import React, { useEffect, useRef, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './TopBar.css'
import HomeBanners from '../../Pages/Home/HomeBanners/HomeBanners/HomeBanners';

const TopBar = (props) => {
    const [navBackground, setNavBackground] = useState(false)
    const navRef = useRef()
    navRef.current = navBackground
    useEffect(() => {
        const handleScroll = () => {
            const show = window.scrollY > 50
            if (navRef.current !== show) {
                setNavBackground(show)
            }
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)

        }
    }, [])


    return (
        <div className='mb-5 topBar'>
            <Navbar expand="lg" fixed="top" className="nav" style={{
                transition: '.35s ease-in-out', backgroundColor: navBackground ? '#272727' : 'transparent', boxShadow: navBackground ? "0px 5px 15px rgba(0, 0, 0, 0.1)" : 'none'
            }}>
                <Navbar.Brand className='navLogo1'>

                    <img width={50} src="https://webredox.net/demo/wp/bauen/light/el/multi/demo1/wp-content/uploads/2021/09/logo.png" alt="" />

                </Navbar.Brand>
                <div className='navContainer '>
                    {
                        navBackground ? (<>
                            <Navbar.Brand className='navLogo2'>

                                <img width={75} src="https://webredox.net/demo/wp/bauen/light/el/multi/demo1/wp-content/uploads/2021/09/logo.png" alt="" />

                            </Navbar.Brand>

                        </>) : (<>
                            <div className='navLogo3Container'>
                                <Navbar.Brand className='navLogo3'>

                                    <img width={75} src="https://webredox.net/demo/wp/bauen/light/el/multi/demo1/wp-content/uploads/2021/09/logo.png" alt="" />
                                </Navbar.Brand>

                                <h2 className='navLogoText-1'>Limit <br />Designer <br /> Ltd</h2>

                            </div>

                        </>)
                    }

                </div>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="" >
                    <Nav className="ms-auto">
                        <Nav.Link href="/" className="navLink">Home</Nav.Link>
                    </Nav>
                    <Nav >
                        <Nav.Link href="#about" className="navLink">About Us</Nav.Link>
                    </Nav>
                    <Nav className="">
                        <Nav.Link href="#projects" className="navLink">Projects</Nav.Link>
                    </Nav>
                    <Nav className="">
                        <Nav.Link href="#onGoingProjects" className="navLink">On Going Projects</Nav.Link>
                    </Nav>
                    <Nav className="">
                        <Nav.Link href="#services" className="navLink">Services</Nav.Link>
                    </Nav>
                    <Nav className="">
                        <Nav.Link href="#team" className="navLink">Our Team</Nav.Link>
                    </Nav>
                    <Nav className="" style={{ marginRight: "75px" }}>
                        <Nav.Link href="#contact" className="navLink">Contact Us</Nav.Link>
                    </Nav>

                </Navbar.Collapse>
            </Navbar>
            <HomeBanners props={props} />
        </div >
    );
};

export default TopBar;